export default "__VITE_ASSET__D9GHr3sQ__"